import { render, staticRenderFns } from "./deck.vue?vue&type=template&id=5f2e4870"
import script from "./deck.vue?vue&type=script&lang=js"
export * from "./deck.vue?vue&type=script&lang=js"
import style0 from "./deck.vue?vue&type=style&index=0&id=5f2e4870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports